import React, { useMemo, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { FaRegBuilding, FaFemale, FaMale } from "react-icons/fa";
import { BiMaleFemale } from "react-icons/bi";

const PropertyListSidebar = ({
    properties = [],
    loading = false,
    selectedProperty,
    onSelect,
}) => {
    const [search, setSearch] = useState("");
    const filteredProperties = useMemo(() => {
        const value = search.trim().toLowerCase();

        if (!value) return properties;

        return properties.filter((property) =>
            `${property?.name || ""} ${property?.gId || ""} ${property?.streetAddress || ""}`
                .toLowerCase()
                .includes(value)
        );
    }, [properties, search]);

    const getOccupancy = (property) => {
        const occupied = Number(property?.occupiedBedCount || 0);
        const vacant = Number(property?.vacantBedCount || 0);
        const total = occupied + vacant;

        return total > 0 ? Math.round((occupied / total) * 100) : 0;
    };

    return (
        <aside className="bg-white border border-gray-100 rounded-lg overflow-hidden
      h-[calc(100vh-140px)] min-h-[450px] flex flex-col sticky top-4">

            <div className="px-4 py-3 border-b border-gray-100 shrink-0">
                <div className="text-sm font-semibold text-gray-800">Properties</div>

                <div className="relative mt-3">
                    <FiSearch
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-10 pointer-events-none"
                        size={15}
                    />

                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search property..."
                        className="relative w-full h-10 pl-9 pr-3 text-sm bg-gray-50 border border-gray-200
            rounded-lg outline-none focus:bg-white focus:border-primary-color transition"
                    />
                </div>
            </div>

            <div className="flex-1 min-h-0 overflow-y-auto">
                {loading && (
                    <div className="px-4 py-8 text-center text-sm text-gray-400">
                        Loading properties...
                    </div>
                )}

                {!loading && filteredProperties.length === 0 && (
                    <div className="px-4 py-8 text-center text-sm text-gray-400">
                        {search ? "No properties found" : "No properties available"}
                    </div>
                )}

                {!loading && filteredProperties.map((property) => {
                    const occupancy = getOccupancy(property);
                    const isSelected = property?.id === selectedProperty?.id;

                    return (
                        <button
                            type="button"
                            key={property.id}
                            onClick={() => onSelect(property)}
                            className={`w-full px-4 py-3.5 flex items-center gap-3 text-left
                border-b border-gray-100 last:border-0 transition
                ${isSelected
                                    ? "bg-cyan-50 border-l-2 border-l-primary-color"
                                    : "hover:bg-gray-50 border-l-2 border-l-transparent"
                                }`}
                        >

                            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100">
                                {property.tenantPreference === 1 ? (
                                    <FaMale className="text-blue-400" />
                                ) : property.tenantPreference === 2 ? (
                                    <FaFemale className="text-pink-400" />
                                ) : (
                                    <BiMaleFemale className="text-purple-400" />
                                )}
                            </div>

                            <div className="min-w-0 flex-1">
                                <div className="font-medium text-sm text-gray-700 truncate">
                                    {property?.name || "Unnamed Property"}
                                </div>
                                <div className="text-xs text-gray-400 mt-0.5 truncate">
                                    {/* #{property?.gId || "NA"} */}
                                    {occupancy}% occupancy
                                </div>
                            </div>

                            {/* <div className="w-14 shrink-0 text-right">
                <div className="text-xs font-semibold text-gray-700">
                  {occupancy}%
                </div>
                <div className="text-[10px] text-gray-400 mb-1">Occupied</div>
                <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary-color rounded-full transition-all"
                    style={{ width: `${occupancy}%` }}
                  />
                </div>
              </div> */}
                        </button>
                    );
                })}
            </div>

            <div className="px-4 py-2.5 border-t border-gray-100 text-xs text-gray-400 shrink-0">
                {search
                    ? `${filteredProperties.length} of ${properties.length} properties`
                    : `${properties.length} properties`}
            </div>
        </aside>
    );
};

export default PropertyListSidebar;
